import * as React from 'react'

function SvgIconMathPercent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="math-percent" aria-labelledby="t-math-percent d-math-percent">
        <title id="t-math-percent">{'Percent'}</title>
        <desc id="d-math-percent">{'Math symbol for percent'}</desc>
        <path d="M24 32c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zm0-10c-2.205 0-4 1.795-4 4s1.795 4 4 4 4-1.795 4-4-1.795-4-4-4zM.293 30.293a.999.999 0 101.414 1.414l30-30A.999.999 0 1030.293.293l-30 30zM8 12c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM8 2C5.793 2 4 3.793 4 6s1.793 4 4 4 4-1.793 4-4-1.793-4-4-4z" />
      </g>
    </svg>
  )
}

export default SvgIconMathPercent
